import { defineMessages } from 'react-intl';

const messages = defineMessages({
  dataShare: {
    id: 'dataShare',
    defaultMessage: 'Data / Share',
  },
  hideDate: {
    id: 'hideDate',
    defaultMessage: 'Hide date',
  },
  hideShare: {
    id: 'hideShare',
    defaultMessage: 'Hide social share',
  },
});

export const schemaDateShare = ({ intl, data }) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.dataShare),
        fields: ['hideDate', 'hideShare'],
      },
    ],
    properties: {
      hideDate: {
        title: intl.formatMessage(messages.hideDate),
        required: false,
        default: false,
        type: 'boolean',
        isDisabled: data.hideShare,
      },
      hideShare: {
        title: intl.formatMessage(messages.hideShare),
        required: false,
        default: false,
        type: 'boolean',
        isDisabled: data.hideDate,
      },
    },
  };
};

export default schemaDateShare;
